import en from "./en.json"
import es from "./es.json"

export const locales = ["en", "es"] as const
export type Locale = (typeof locales)[number]
export const defaultLocale: Locale = "en"

export const localeNames: Record<Locale, string> = {
  en: "English",
  es: "Español",
}

type Dictionary = typeof en
const dictionaries: Record<Locale, Dictionary> = { en, es }

export function getDictionary(locale: Locale): Dictionary {
  return dictionaries[locale] ?? dictionaries.en
}

/**
 * Resolve a dot-path key like "nav.openCalls" from a dictionary object.
 * Supports simple interpolation: "{days}" in the value is replaced
 * by the matching key in the `params` object.
 */
export function t(
  dict: Dictionary,
  key: string,
  params?: Record<string, string | number>
): string {
  const parts = key.split(".")
  let result: unknown = dict
  for (const part of parts) {
    if (result && typeof result === "object" && part in result) {
      result = (result as Record<string, unknown>)[part]
    } else {
      return key // fallback: return the key itself
    }
  }
  if (typeof result !== "string") return key
  if (!params) return result
  return result.replace(/\{(\w+)\}/g, (_, k) =>
    params[k] !== undefined ? String(params[k]) : `{${k}}`
  )
}
